import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { setNativeAppListenerReady } from '../../redux/action/system'
import { handleKassaAppListener, publishKassaWebListenerReadyMessage } from './helper'

const NativeAppListener = () => {
	const dispatch = useDispatch()

	useEffect(() => {
		const messageListener = message => {
			handleKassaAppListener(message, dispatch)
		}
		window.addEventListener('message', messageListener, true)
		dispatch(setNativeAppListenerReady(true))
		publishKassaWebListenerReadyMessage()

		return () => {
			dispatch(setNativeAppListenerReady(false))
			window.removeEventListener('message', messageListener, true)
		}
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return null
}

NativeAppListener.displayName = 'NativeAppListener'
export default NativeAppListener
